import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css'; // グローバルCSSをインポート
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installBlankWindowGuard } from './utils/blankWindowGuard';

// Flutter(WKWebView) 内で about:blank の外部起動ハングを防ぐため、
// 空/about:blank の window.open を早期に無効化する。
installBlankWindowGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
